import React, { useContext, useEffect } from 'react';
//import PropTypes from 'prop-types';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import { useStyles } from '../../../../home/useStyles';
import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
} from '@mui/material';

function PickUpSettings(props) {
    const { orderType = 'catering', mode } = props;
    const resauInfoContext = useContext(RestauInfoContext);
    const restauHook = resauInfoContext.restauHook;
    const [loaded, setLoaded] = React.useState(false);
    const [saveMessage, setSaveMessage] = React.useState('');
    const classes = useStyles();
    const [scheduledOrderConfig, setScheduledOrderConfig] =
        React.useState(null);

    async function loadPickUpData(restauHook) {
        setLoaded(true);
        if (!restauHook.restauId) {
            setLoaded(false);
            return;
        }
        if (!window.customerApp.auth().currentUser) {
            //debugger;
            history.push('/login');
            return;
        }
        const token = await window.customerApp.auth().currentUser.getIdToken();

        let config = {
            headers: {
                token: token,
            },
        };
        console.log('Restau Hook from restaurant: ' + restauHook.restauId);
        const admin = window.customerApp.database();
        let payAtRef = await admin.ref(
            'menus/' +
                restauHook.restauId +
                (orderType === 'catering'
                    ? '/details/cateringConfig/scheduledOrderConfig'
                    : '/details/scheduledOrderConfig')
        );
        await payAtRef
            .once('value')
            .then(function (snapshot) {
                let result = snapshot.val();
                let noDefault = false;
                if (!result) {
                    //result = { enabled: false, scheduledOrderDays: 0 };
                    noDefault = true;
                }
                if (noDefault) {
                    result = { enabled: false, scheduledOrderDays: 0 };
                    setScheduledOrderConfig(result);
                } else {
                    setScheduledOrderConfig(result);
                }

                setLoaded(false);

                return result;
            })
            .catch(function (error) {
                setLoaded(false);
                console.log(error);
            });

        return;
    }

    async function handlePickUpSettingsChange(e, settingName) {
        let scheduledOrderConf = { ...scheduledOrderConfig };
        setSaveMessage('');
        if (settingName === 'pickupEnabled') {
            if (e.target.value === 'enabled') {
                scheduledOrderConf['enabled'] = true;
                //setEnabled(true);
                //setScheduledOrderConfig(scheduledOrderConf);
            } else {
                scheduledOrderConf['enabled'] = false;
                //setEnabled(false);
                //setScheduledOrderConfig(scheduledOrderConf);
            }
        } else if (settingName === 'scheduledOrderDays') {
            scheduledOrderConf['scheduledOrderDays'] = e.target.value;
        }
        setScheduledOrderConfig(scheduledOrderConf);
    }

    async function updatePickUpSettings(restauHook) {
        const database = window.customerApp.database();
        setLoaded(true);

        let scheduledOrderConf = { ...scheduledOrderConfig };
        //scheduledOrderConf['enabled'] = enabled;

        let scheduledOrderSettings = {};
        scheduledOrderSettings[
            'menus/' +
                restauHook.restauId +
                (orderType === 'catering'
                    ? '/details/cateringConfig/scheduledOrderConfig'
                    : '/details/scheduledOrderConfig')
        ] = scheduledOrderConf;

        await database
            .ref()
            .update(scheduledOrderSettings)
            .then(function () {
                setSaveMessage('Pickup settings updated successfully');
            })
            .catch(function (error) {
                alert('Error while saving please try again');
                console.log(error);
                setLoaded(false);
                return;
            });

        setLoaded(false);
    }

    useEffect(() => {
        loadPickUpData(restauHook);
    }, [restauHook.restauId]);

    return (
        <div>
            {!scheduledOrderConfig ? (
                <div>
                    <img
                        className={classes.loadingImage}
                        src="../../img/spinner.gif"
                    />
                </div>
            ) : (
                <>
                    <div>
                        <div
                            style={{
                                maxWidth: 350,
                                position: 'relative',
                                zIndex: 1,
                            }}
                        >
                            <FormControl component="fieldset">
                                {/* <FormLabel component="legend">
                                    Pickup Enabled
                                </FormLabel> */}
                                <h2>Pickup Enabled</h2>
                                <RadioGroup
                                    aria-label="print1"
                                    name="print1"
                                    value={
                                        scheduledOrderConfig?.enabled ===
                                        undefined
                                            ? 'enabled'
                                            : scheduledOrderConfig.enabled
                                            ? 'enabled'
                                            : 'disabled'
                                    }
                                    onChange={(e) =>
                                        handlePickUpSettingsChange(
                                            e,
                                            'pickupEnabled'
                                        )
                                    }
                                >
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={6}
                                            style={{
                                                marginTop: '10px',
                                                marginBottom: '5px',
                                            }}
                                        >
                                            <FormControlLabel
                                                value="enabled"
                                                control={<Radio />}
                                                label="Enable"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            style={{
                                                marginTop: '10px',
                                                marginBottom: '5px',
                                            }}
                                        >
                                            <FormControlLabel
                                                value="disabled"
                                                control={<Radio />}
                                                label="Disabled"
                                            />
                                        </Grid>
                                    </Grid>
                                </RadioGroup>
                            </FormControl>
                        </div>
                        {scheduledOrderConfig.enabled && (
                            <>
                                <TextField
                                    id="scheduledOrderDays"
                                    label="Scheduled Pickup Order Ahead days"
                                    variant="outlined"
                                    inputProps={{
                                        inputMode: 'numeric',
                                    }}
                                    value={
                                        scheduledOrderConfig.scheduledOrderDays
                                    }
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                days
                                            </InputAdornment>
                                        ),
                                    }}
                                    onChange={(e) =>
                                        handlePickUpSettingsChange(
                                            e,
                                            'scheduledOrderDays'
                                        )
                                    }
                                />
                            </>
                        )}
                        <br />
                        <br />
                    </div>
                    {loaded === true ? (
                        <div>
                            <img
                                height="75px"
                                className={classes.loadingImage}
                                src="../../img/spinner.gif"
                            />
                        </div>
                    ) : (
                        <>
                            <div style={{ maxWidth: 350 }}>
                                <Button
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        updatePickUpSettings(restauHook);
                                    }}
                                    style={{ width: 'auto', marginTop: 10 }}
                                >
                                    Update
                                </Button>
                            </div>
                            <div
                                style={{
                                    paddingLeft: '10px',
                                    marginTop: '30px',
                                }}
                            >
                                {saveMessage}
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
}

PickUpSettings.propTypes = {};

export default PickUpSettings;
